module.exports = __webpack_public_path__ + "static/media/poliymer-alternative.74031f64.png";